/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo } from 'react';
import Section from '../../layout/Section';
import usePagination from './usePagination';
import NavButton from './NavButton';
import PageButton from './PageButton';
const Pager = React.memo(({ offset, total_count, limit, padding, handleClick, usesLinks, gatsbyLink, queryParam, location, styles }) => {
    const { paginationLabels, currentPage, isNextPagePossible, isPreviousPagePossible, shouldShowPager } = usePagination(total_count, offset, limit, padding);
    const generateHref = React.useCallback((pageNumber, isPossible) => {
        if (isPossible === false) {
            return '';
        }
        // Gatsby
        if (usesLinks && location) {
            const pagePath = pageNumber === 1 ? '' : `page-${pageNumber}/`;
            if (location.pathname.match(/page-/)) {
                return location.pathname.replace(/page-\d+\//, pagePath);
            }
            else {
                return `${location.pathname}${pagePath}`;
            }
        }
        if (!queryParam || typeof location === 'undefined') {
            return '';
        }
        const urlParams = new URLSearchParams(location.search);
        pageNumber === 1
            ? urlParams.delete(queryParam)
            : urlParams.set(queryParam, String(pageNumber));
        const search = urlParams.toString() ? `?${urlParams}` : '';
        return `${location.pathname}${search}${location.hash}`;
    }, [location, queryParam, usesLinks]);
    const processedPageNumbers = paginationLabels.map((label, i) => {
        const props = usesLinks && label !== '…'
            ? {
                isLink: usesLinks,
                gatsbyLink,
                href: generateHref(+label),
                styles: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            }
            : {
                handleClick: handleClick
            };
        return (React.createElement(PageButton
        // 'i' is necessary because there might be two '…' labels
        , { 
            // 'i' is necessary because there might be two '…' labels
            key: label + i, label: label, currentPage: currentPage, limit: limit, ...props }));
    });
    const mergedStyles = useMemo(() => ({
        flexDirection: 'row',
        ...styles
    }), [styles]);
    const previousProps = React.useMemo(() => usesLinks
        ? {
            isLink: usesLinks,
            gatsbyLink,
            href: generateHref(currentPage - 1, isPreviousPagePossible),
            styles: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        }
        : {
            handleClick: handleClick
        }, [usesLinks, gatsbyLink, generateHref, currentPage, isPreviousPagePossible, handleClick]);
    const nextProps = React.useMemo(() => usesLinks
        ? {
            isLink: usesLinks,
            gatsbyLink,
            href: generateHref(currentPage + 1, isNextPagePossible),
            styles: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        }
        : {
            handleClick: handleClick
        }, [usesLinks, gatsbyLink, generateHref, currentPage, isNextPagePossible, handleClick]);
    return shouldShowPager ? (React.createElement(Section, { centered: true, styles: mergedStyles },
        React.createElement(NavButton, { ...previousProps, offset: offset, limit: limit, direction: "backward", alt: "previous results", disabled: !isPreviousPagePossible }),
        processedPageNumbers,
        React.createElement(NavButton, { offset: offset, ...nextProps, limit: limit, direction: "forward", alt: "next results", disabled: !isNextPagePossible }))) : null;
});
export default Pager;
//# sourceMappingURL=index.js.map